import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import "../index.css";
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; 


function Field7(props) {
  const [isUpdated, setIsUpdated] = useState(false);
  const { quill, quillRef } = useQuill();
  const { item, actions } = props;
  
  useEffect(() => {
    if (quill) {
      quill.enable(!item.isReadonly);
      quill.clipboard.dangerouslyPasteHTML(item.Valoare);
      quill.on('text-change', () => {
        setIsUpdated(true);
      });
    }
  }, [quill,item]);
  return (
    <div
      id={`f7-${item.Id}`}
      key={item.Id}
      className={`doc-field ${
        item.Jprop.className ? item.Jprop.className : ""
      }`}
    >
      <div id={`f7l-${item.Id}`} className="doc-field-label">
        {item.Caption + (item.Obligatoriu ? " *" : "")}
      </div>
      <div 
        ref={quillRef} 
        onBlur={()=>{isUpdated &&  !item.isReadonly && actions.updateValue(item, quill.getSemanticHTML());}}
        className={"rich-text-editor" + (item.isReadonly ? " disabled" : "")}
        />
    </div>
  );
}
export default observer(Field7);
